export class SubTopic {
  SubTopicId: number;
  SubTopicName: string;
}
